<section class="partners-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="page-header">
      <div class="header-left">
        <h3 class="title">Partners</h3>
        <p class="subtitle">Partners details page</p>
      </div>
    </div>
  </div>

  <!-- Search -->
  <div class="filters-section">
    <app-search-box tooltipText="Search By firstName, lastName, and email" (search)="onSearch($event)"></app-search-box>
    <p-select [options]="partnerStatuses" [(ngModel)]="selectedPartnerStatus" optionLabel="label" optionValue="value"
      [showClear]="true" class="partner-status-dropdown" placeholder="Select status" (onChange)="onStatusChange($event)">
    </p-select>
  </div>

  <!-- Table -->
  <div class="table-container shadow">
    <table class="partners-table">
      <thead>
        <tr>
          <th class="checkbox-col">
            <input type="checkbox" [checked]="allSelected()" (change)="toggleSelectAll()" />
          </th>

          <th>Name</th>
          <th>Email</th>
          <th class="sortable" (click)="onSort('status')">Status <span class="sort-indicator">{{ getSortIcon('status')
          }}</span></th>
          <th class="sortable" (click)="onSort('createdAt')">Join Date <span class="sort-indicator">{{
          getSortIcon('createdAt') }}</span></th>
          <th class="text-start">Action</th>
        </tr>
      </thead>
      <tbody>
        @if (this.loading()) {
          <tr>
            <td colspan="100%">
              <app-spinner-loader [width]="35"></app-spinner-loader>
            </td>
          </tr>
        } @else if (partners().length === 0) {
          <tr>
            <td colspan="100%" class="no-data-cell">No partner found</td>
          </tr>
        } @else {
          @for (p of partners(); track trackByPartnerId($index, p)) {
            <tr [class.selected]="p.selected">
              <td class="checkbox-col">
                <input type="checkbox" [(ngModel)]="p.selected" (change)="updateSelectAllState()" />
              </td>
              <td class="partner-name">{{ getDisplayName(p) | titlecase}}</td>
              <td class="text-muted">{{ getEmail(p) }}</td>
              <td class="status">
                <span class="status-badge" [ngClass]="'status-' + (p.status || 'pending')">
                  {{ p.status || "pending" }}
                </span>
              </td>
              <td class="join-date">
                {{ p.submittedAt | date: "yyyy-MM-dd HH:mm" }}
              </td>
              <td class="action">
                <div class="actions">
                  <button class="btn btn-view" (click)="view(p)">View</button>
                  @if (p.status == "pending") {
                    <button class="btn btn-accept" (click)="accept(p)" [disabled]="!canAccept(p)">
                      {{ "Accept" }}
                    </button>
                    <button class="btn btn-reject" (click)="reject(p)" [disabled]="!canReject(p)">
                      {{ "Reject" }}
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    <div class="pagination-section">
      <div class="pagination-info">
        <span>Showing {{ startIndex() }} to {{ endIndex() }} of {{ totalCount() }} Entries</span>
      </div>
      <div class="d-flex gap-2">
        <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
        <select id="pageSizeSelect" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)"
          class="form-select" style="width: 70px;">
          @for (size of pageSizes; track size) {
            <option [value]="size">
              {{ size }}
            </option>
          }
        </select>
        <button class="btn btn-outline pagination-btn"
          [disabled]="currentPage() === 1 || loading()" (click)="previousPage()">
          &lt; Prev
        </button>
        <button class="btn btn-outline pagination-btn"
          [disabled]="currentPage() === totalPages() || loading()" (click)="nextPage()">
          Next &gt;
        </button>
      </div>
    </div>
  </div>
</section>

@if (isVisible()) {
  <app-partner-request-model (message)="response($event)" [visible]="isVisible()" [type]="partnerType()"
    (onClose)="Close()" />
  }
  @if (isView() && selectedPartner()) {
    <app-partner-view [visible]="isView()" (onClose)="closeView()" [partner]="selectedPartner()!" />
  }
